import {
  GET_ACCOUNT_ALERTS_PREFERENCES_PENDING,
  GET_ACCOUNT_ALERTS_PREFERENCES_FULFILLED,
  GET_ACCOUNT_ALERTS_PREFERENCES_FAILED,
  GET_CONTACT_PREFERENCES_FULFILLED,
  ADD_BANKING_ALERT_VALUE,
  UPDATE_BANKING_ALERT_VALUES,
  ADD_CURRENT_OPERATING_VALUE,
  UPDATE_DELIVERY_METHOD,
  DELIVERY_ADDRESS_UPDATE_ERROR,
  DELIVERY_ADDRESS_UPDATE_PENDING,
  DELIVERY_ADDRESS_UPDATE_FULFILLED,
  BANKING_ALERTS_PENDING,
  BANKING_ALERTS_ERROR,
  BANKING_ENABLE_ALERTS_FULFILLED,
  BANKING_ENABLE_ALERTS_PENDING,
  BANKING_ENABLE_ALERTS_ERROR
} from "../actionTypes";
import _ from 'lodash'
import AppHelper from "../../helpers/appHelper";
import { accountAlerts } from "../accountAlerts/accountAlertsAction";
import axios from "axios";
import {
  CONTACT_PREFERENCES_ENDPOINT,
  BANKING_ALERTGROUPS_ENDPOINT,
  DELIVERYMETHODS_ENDPOINT,

} from "../../helpers/apiUrls";
import ActionCreator, { pingEventService } from "../../helpers/apiRequestor";
import {
  HttpType
} from "../../helpers/constantValues";
import { NotificationManager } from 'react-notifications';


export const getContactPreferences = bankingAlertGroup => {

  return (dispatch) => dispatch(ActionCreator(
    {
      url: AppHelper.getMiddlewareApiUrl(CONTACT_PREFERENCES_ENDPOINT + `/${bankingAlertGroup}/CustomerPreferences`),
      method: HttpType.GET,
      headers: { ...AppHelper.getSessionTokenHeaders() }
    },
    BANKING_ALERTS_PENDING,
    GET_CONTACT_PREFERENCES_FULFILLED,
    BANKING_ALERTS_ERROR
  ));
};

export const removeContactPreferences = (name, value, id) => (
  dispatch,
  getState
) => {
  pingEventService();
  dispatch({ type: BANKING_ENABLE_ALERTS_PENDING })
  return axios
    .delete(
      AppHelper.getMiddlewareApiUrl(CONTACT_PREFERENCES_ENDPOINT + `/${name}/CustomerPreferences`),
      {
        data: {
          deliveryMethodId: id
        },
        headers: { ...AppHelper.getSessionTokenHeaders() }
      }
    )
    .then(response => {
      const state = getState();
      dispatch({ type: BANKING_ENABLE_ALERTS_FULFILLED })
      dispatch({
        type: GET_CONTACT_PREFERENCES_FULFILLED,
        data: [
          ...state.accountAlertsReducer.contactPreferences.filter(
            s => s !== id
          )
        ]
      });
    }).catch(res => {
      dispatch({ type: BANKING_ENABLE_ALERTS_ERROR })
      NotificationManager.error('unable to process');
    });
};

export const addDeliveryMethod = data => dispatch => {
  
  dispatch({ type: DELIVERY_ADDRESS_UPDATE_PENDING })
  return axios
    .post(AppHelper.getApiUrl(DELIVERYMETHODS_ENDPOINT), data, {
      headers: { ...AppHelper.getSessionTokenHeaders() }
    })
    .then(response => {
      dispatch(accountAlerts(true));
      dispatch({ type: DELIVERY_ADDRESS_UPDATE_FULFILLED })
      NotificationManager.success('Email address created successfully');
      return response.data;
    }).catch(res => {
    
      const message = _.get(res, 'response.data.errors[0].message', 'Unable to process')
      NotificationManager.error(message);
      dispatch({ type: DELIVERY_ADDRESS_UPDATE_ERROR })
      return null;
    });
};

export const addContactPreferences = (name, value, id) => (dispatch, getState) => {
  
  pingEventService();
  dispatch({ type: BANKING_ENABLE_ALERTS_PENDING })
  return axios
    .post(
      AppHelper.getMiddlewareApiUrl(CONTACT_PREFERENCES_ENDPOINT + `/${name}/CustomerPreferences`),
      {
        deliveryMethodId: id
      },
      {
        headers: { ...AppHelper.getSessionTokenHeaders() }
      }
    )
    .then(response => {
      const state = getState();
      dispatch({ type: BANKING_ENABLE_ALERTS_FULFILLED })
      dispatch({
        type: GET_CONTACT_PREFERENCES_FULFILLED,
        data: [
          ...state.accountAlertsReducer.contactPreferences,
          id
        ]
      });
    }).catch(res => {
      dispatch({ type: BANKING_ENABLE_ALERTS_ERROR })
      NotificationManager.error('unable to process');
    });
};


export const updateDeliveryMethod = (data) => (dispatch) => {

  pingEventService();
  dispatch({ type: DELIVERY_ADDRESS_UPDATE_PENDING })
  return axios.post(AppHelper.getApiUrl(`/api/DeliveryMethods/${data.id}`), data, {
    headers: { ...AppHelper.getSessionTokenHeaders() }
  })
    .then(response => {
      dispatch({ type: DELIVERY_ADDRESS_UPDATE_FULFILLED })
      dispatch({ type: UPDATE_DELIVERY_METHOD, data: response.data })
    }).catch(res => {
     
      const message = _.get(res, 'response.data.errors[0].message', 'Unable to process')
      NotificationManager.error(message);
      dispatch({ type: DELIVERY_ADDRESS_UPDATE_ERROR })
      return null;
    });
}

export const triggerVerificationCode = (data, verificationType) => dispatch => {
  dispatch({ type: DELIVERY_ADDRESS_UPDATE_PENDING })
  return axios.post(AppHelper.getApiUrl(`/api/DeliveryMethods/${data.id}/Challenge`), data, {
    headers: {
      ...AppHelper.getSessionTokenHeaders()
    }
  })
    .then(response => {
      NotificationManager.success('One-Time Code sent');
      dispatch({ type: DELIVERY_ADDRESS_UPDATE_FULFILLED })
      return true;
    }).catch(() => {
      dispatch({ type: DELIVERY_ADDRESS_UPDATE_ERROR })
    });
};

export const submitVerificationCode = (data, verificationType) => (dispatch) => {
  dispatch({ type: DELIVERY_ADDRESS_UPDATE_PENDING })
  return axios
    .post(AppHelper.getApiUrl(`/api/DeliveryMethods/${data.id}/Verify`), data, {
      headers: {
        ...AppHelper.getSessionTokenHeaders()
      }
    })
    .then(response => {
      dispatch(accountAlerts(true));
      dispatch({ type: DELIVERY_ADDRESS_UPDATE_FULFILLED })
      NotificationManager.success('Verified Successfully ');
      return true;
    }).catch(res => {
      dispatch({ type: DELIVERY_ADDRESS_UPDATE_ERROR })
      const message = _.get(res, 'response.data.errors[0].message', 'Unable to process')
      NotificationManager.error(message);
      return false
    });
};

export const saveAndVerifyDeliveryMethod = data => (dispatch) => {
  dispatch({ type: DELIVERY_ADDRESS_UPDATE_PENDING })
  return axios.post(
    AppHelper.getApiUrl(DELIVERYMETHODS_ENDPOINT + `/${data.id}`), data, {
    headers: { ...AppHelper.getSessionTokenHeaders() }
  }).then(response => {
    dispatch({ type: DELIVERY_ADDRESS_UPDATE_FULFILLED })
    NotificationManager.success('Updated successfully');
    dispatch({ type: UPDATE_DELIVERY_METHOD, data: response.data })
    return response.data;
  }).catch(res => {
    const message = _.get(res, 'response.data.errors[0].message', 'Unable to process')
    NotificationManager.error(message);
    dispatch({ type: DELIVERY_ADDRESS_UPDATE_ERROR })
    return null;
  });
};

export const deleteDeliveryAddress = data => dispatch => {
  dispatch({ type: DELIVERY_ADDRESS_UPDATE_PENDING })
  return axios
    .delete(AppHelper.getApiUrl(DELIVERYMETHODS_ENDPOINT + `/${data.id}`),
      {
        headers: { ...AppHelper.getSessionTokenHeaders() }
      }
    )
    .then(response => {
      NotificationManager.success('Email address deleted successfully');
      dispatch(accountAlerts(true));
      dispatch({ type: DELIVERY_ADDRESS_UPDATE_FULFILLED })
    }).catch((res) => {
      dispatch({ type: DELIVERY_ADDRESS_UPDATE_ERROR })
      const message = _.get(res, 'response.data.errors[0].message', 'Unable to process')
      NotificationManager.error(message);
    });
};

export const updateBankingAlertValues = data => dispatch => {
  dispatch({
    type: UPDATE_BANKING_ALERT_VALUES,
    payload: data
  });
};

export const addBankingAlertValue = data => dispatch => {
  dispatch({
    type: ADD_BANKING_ALERT_VALUE,
    payload: data
  });
};

export const addCurrentOperatingValue = data => dispatch => {
  dispatch({
    type: ADD_CURRENT_OPERATING_VALUE,
    payload: data
  });
};

export const deletePhoneNumber = data => dispatch => {
  return axios
    .delete(AppHelper.getApiUrl(DELIVERYMETHODS_ENDPOINT) + `/${data.id}`, {
      headers: { ...AppHelper.getSessionTokenHeaders() }
    })
    .then(response => {
      NotificationManager.success('Phone number deleted successfully');
      dispatch(accountAlerts(true));
    }).catch(res => {
      const message = _.get(res, 'errors[0].message', 'Unable to process')
      NotificationManager.error(message);
    });
};

export const getDeliveryMethod = () => {

  return (dispatch) => dispatch(ActionCreator(
    {
      url: AppHelper.getMiddlewareApiUrl(BANKING_ALERTGROUPS_ENDPOINT),
      method: HttpType.GET,
      headers: { ...AppHelper.getSessionTokenHeaders() }
    },
    GET_ACCOUNT_ALERTS_PREFERENCES_PENDING,
    GET_ACCOUNT_ALERTS_PREFERENCES_FULFILLED,
    GET_ACCOUNT_ALERTS_PREFERENCES_FAILED
  ));
};

export const addPhoneNumber = data => dispatch => {
  dispatch({ type: DELIVERY_ADDRESS_UPDATE_PENDING })
  return axios
    .post(AppHelper.getApiUrl(DELIVERYMETHODS_ENDPOINT), data, {
      headers: { ...AppHelper.getSessionTokenHeaders() }
    })
    .then(response => {
      dispatch(accountAlerts(true));
      dispatch({ type: DELIVERY_ADDRESS_UPDATE_FULFILLED })
      NotificationManager.success("Phone number created successfully")
      return response.data;

    }).catch(res => {
      const message = _.get(res, 'response.data.errors[0].message', 'Unable to process')
      NotificationManager.error(message);
      dispatch({ type: DELIVERY_ADDRESS_UPDATE_ERROR })
      return null;
    });
};
